import { style } from '@vanilla-extract/css';

export const scrollWrapper = style({
  overflow: 'hidden',
  position: 'relative',
  display: 'inline-block',
  verticalAlign: 'top',
  whiteSpace: 'nowrap',
  transition: '0.5s all ease-in-out',
  '@media': {
    'only screen and (--mobile)': {
      verticalAlign: 'top',
    },
  },
});

export const animateShow = style({});
export const animateUp = style({});

export const animated = style({
  display: 'block',
  position: 'absolute',
  opacity: 0,
  transition: '0.5s all ease-in-out',
  transform: 'translateY(100%)',
  whiteSpace: 'nowrap',
  height: '100%',

  selectors: {
    [`&${animateShow}`]: {
      transform: 'translateY(0%)',
      opacity: 1,
    },
    [`&${animateUp}`]: {
      transform: 'translateY(-100%)',
      opacity: 0,
    },
  },
});
